exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    background-color: #F0F0F0;\r\n    display: block;\r\n}\r\n.assign-vhcle-popup-wrapper {\r\n    padding: 15px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/wave-control-popups/assign-vehicle-popup/assign-vehicle-popup.component.css
// module id = ../../../../../src/app/shared/lookup/wave-control-popups/assign-vehicle-popup/assign-vehicle-popup.component.css
// module chunks = main